import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/PageHeader';

export function ForecastPage() {
    const { t } = useTranslation();
    return (
        <>
            <PageHeader title={t('forecast.title')} subtitle={t('forecast.subtitle')} />
            <Box sx={{ p: 3 }}>
                <Typography>{t('forecast.placeholder')}</Typography>
            </Box>
        </>
    );
}
